export interface IMetricItem {
    name: string;
    value: number;
  }

  export interface IMetricCategory {
    name: string;
    items: IMetricItem[];
  }

  export class MetricItem implements IMetricItem {
    name: string;
    value: number;

    constructor(metric: string, data: IMetricItem) {
      this.name = (metric + '_' + data.name)?.toUpperCase() || '' ;
      this.value = data.value;
    }
  }

  export class MetricCategory implements IMetricCategory {
    name: string;
    items: MetricItem[];

    constructor(data: IMetricCategory) {
      this.name = data.name;
      this.items = data.items.map(item => new MetricItem(data.name,item));
    }
  }

  export interface IPracticeMetrics {
    practice_id: number;
    month: string;
    metrics: IMetricCategory[];
  }

  export class PracticeMetrics implements IPracticeMetrics {

    practice_id: number;
    month: string;
    metrics: MetricCategory[];

    constructor(data?: IPracticeMetrics) {
      if (data) {
        this.practice_id = data.practice_id;
        this.month = data.month;
        this.metrics = data.metrics.map(metric => new MetricCategory(metric));
      } else {
        this.practice_id = 0;
        this.month = '';
        this.metrics = [];
      }
    }

  }
